import {useEffect, useRef} from 'react';
import {storageConfigurationService} from '@/services/storageConfigurationService';

const ID_KEY = 'media.storage.provider';
const CFG_KEY = 'selected_storage_config';

export function useEnsureStorageSelection() {
    const ranRef = useRef(false);

    useEffect(() => {
        if (ranRef.current) return;
        ranRef.current = true;

        const ensure = async () => {
            try {
                const configs = await storageConfigurationService.getConfigurations();
                if (!configs || configs.length === 0) {
                    // Clear stale selection if no configs exist
                    try {
                        localStorage.removeItem(ID_KEY);
                        localStorage.removeItem(CFG_KEY);
                    } catch {
                    }
                    return;
                }

                const getSavedId = () => {
                    try {
                        const idStr = localStorage.getItem(ID_KEY);
                        if (!idStr) return null;
                        const id = parseInt(idStr, 10);
                        return Number.isNaN(id) ? null : id;
                    } catch {
                        return null;
                    }
                };

                const savedId = getSavedId();
                const savedCfg = (() => {
                    try {
                        const raw = localStorage.getItem(CFG_KEY);
                        return raw ? JSON.parse(raw) : null;
                    } catch {
                        return null;
                    }
                })();

                const isValid = (id: number | null) => id !== null && configs.some((c) => c.id === id && c.is_active !== false);

                let next = null as any;
                if (isValid(savedId ?? savedCfg?.id ?? null)) {
                    next = configs.find((c) => c.id === (savedId ?? savedCfg?.id));
                } else {
                    next =
                        configs.find((c) => c.is_default && c.is_active !== false) ||
                        configs.find((c) => c.is_active !== false) ||
                        configs[0];
                }

                if (next) {
                    try {
                        localStorage.setItem(ID_KEY, String(next.id));
                        localStorage.setItem(CFG_KEY, JSON.stringify(next));
                    } catch {
                    }
                }
            } catch {
                // ignore bootstrap errors
            }
        };

        void ensure();
    }, []);
}
